<template>
  <section class="tags-inputs">
    <section-title>TagsInput Component</section-title>
    <form-wrap>
      <form-field-set>
        <tags-input
          v-model="tagsInput"
          :direction="direction"
          :options="options"
          label="Tag Input"
          name="tagsInput1"
          placeholder="Tag auswählen"
        />
        <tags-input
          v-model="tagsInput"
          :direction="direction"
          :is-disabled="true"
          :options="options"
          label="Tag Input disabled"
          name="tagsInput2"
          placeholder="Tag auswählen"
        />
      </form-field-set>
    </form-wrap>
  </section>
</template>

<script>
import PlaygroundCommmonMixin from '@/mixins/pages/playground/PlaygroundCommon'
import FormFieldSet from '@/components/forms/FormFieldSet'
import FormWrap from '@/components/forms/FormWrap'
import SectionTitle from '@/components/ui/SectionTitle'
import TagsInput from '@/components/forms/TagsInput'

export default {
  name: 'TagsInputs',
  mixins: [PlaygroundCommmonMixin],
  components: {
    FormFieldSet,
    FormWrap,
    SectionTitle,
    TagsInput
  },
  data () {
    return {
      tagsInput: []
    }
  },
  computed: {
    options () {
      return [
        { label: 'Innovation', value: 'innovation' },
        { label: 'Transportation', value: 'transportation' },
        { label: 'Fun', value: 'fun' }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/playground/TagsInputs.vue